import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "../i18n/useTranslation";

function Carousel({ images }) {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const totalIndex = images.length;

  // 10초마다 캐러셀 넘어가도록 설정
  useEffect(() => {
    const timer = setInterval(() => {
        setCurrentIndex((v) => (v + 1) % totalIndex);
    }, 10000);
    return () => clearInterval(timer);}, [totalIndex]);

  const handleButtonClick = (e, link) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(link);
  };

  if (!images || totalIndex === 0) return <div>{t('homePage.carousel.noImages')}</div>;

  return (
    <div className="box-group-col">
        <div className="box-group">
            <div className="carousel-container">
                <div className="carousel">
                    {images[currentIndex].link ? (
                        <Link to={images[currentIndex].link} className="cell">
                            <img
                                src={images[currentIndex].src}
                                alt={`carousel-${currentIndex}`}
                            />
                            <div className="carousel-content-overlay">
                                {images[currentIndex].title && (
                                    <div className="carousel-title">
                                        {images[currentIndex].title}
                                    </div>
                                )}
                                {images[currentIndex].description && (
                                    <div className="carousel-description">
                                        {images[currentIndex].description}
                                    </div>
                                )}
                                {images[currentIndex].link && (
                                    <button
                                        type="button"
                                        onClick={(e) => handleButtonClick(e, images[currentIndex].link)}
                                        className="carousel-button"
                                    >
                                        {t('homePage.carousel.viewDetails')}
                                    </button>
                                )}
                            </div>
                            <div className="carousel-pagination">
                                {images.map((_, idx) => (
                                    <button
                                        key={idx}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setCurrentIndex(idx);
                                        }}
                                        className={`carousel-circle ${idx === currentIndex ? "active" : ""}`}
                                    />
                                ))}
                            </div>
                        </Link>
                    ) : (
                        <div className="cell">
                            <img
                                src={images[currentIndex].src}
                                alt={`carousel-${currentIndex}`}
                            />
                            <div className="carousel-content-overlay">
                                {images[currentIndex].title && (
                                    <div className="carousel-title">
                                        {images[currentIndex].title}
                                    </div>
                                )}
                                {images[currentIndex].description && (
                                    <div className="carousel-description">
                                        {images[currentIndex].description}
                                    </div>
                                )}
                                {images[currentIndex].link && (
                                    <Link to={images[currentIndex].link} className="carousel-button">
                                        {t('homePage.carousel.viewDetails')}
                                    </Link>
                                )}
                            </div>
                            <div className="carousel-pagination">
                                {images.map((_, idx) => (
                                    <button
                                        key={idx}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setCurrentIndex(idx);
                                        }}
                                        className={`carousel-circle ${idx === currentIndex ? "active" : ""}`}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </div>
  );
}

export default Carousel;
